var map = {
	"./editorBaseApi": [
		2212
	],
	"./editorBaseApi.js": [
		2212
	],
	"./editorSimpleWorker": [
		104
	],
	"./editorSimpleWorker.js": [
		104
	],
	"./editorWorker": [
		4225
	],
	"./editorWorker.js": [
		4225
	],
	"./editorWorkerHost": [
		9487
	],
	"./editorWorkerHost.js": [
		9487
	],
	"./findSectionHeaders": [
		730
	],
	"./findSectionHeaders.js": [
		730
	],
	"./getIconClasses": [
		4809
	],
	"./getIconClasses.js": [
		4809
	],
	"./languageFeatureDebounce": [
		8787
	],
	"./languageFeatureDebounce.js": [
		8787
	],
	"./languageFeatures": [
		8715
	],
	"./languageFeatures.js": [
		8715
	],
	"./languageFeaturesService": [
		5468
	],
	"./languageFeaturesService.js": [
		5468
	],
	"./languageService": [
		5297
	],
	"./languageService.js": [
		5297
	],
	"./languagesAssociations": [
		1011
	],
	"./languagesAssociations.js": [
		1011
	],
	"./languagesRegistry": [
		7780
	],
	"./languagesRegistry.js": [
		7780
	],
	"./markerDecorations": [
		3473
	],
	"./markerDecorations.js": [
		3473
	],
	"./markerDecorationsService": [
		4286
	],
	"./markerDecorationsService.js": [
		4286
	],
	"./model": [
		2597
	],
	"./model.js": [
		2597
	],
	"./modelService": [
		3538
	],
	"./modelService.js": [
		3538
	],
	"./resolverService": [
		3537
	],
	"./resolverService.js": [
		3537
	],
	"./semanticTokensDto": [
		1351
	],
	"./semanticTokensDto.js": [
		1351
	],
	"./semanticTokensProviderStyling": [
		452
	],
	"./semanticTokensProviderStyling.js": [
		452
	],
	"./semanticTokensStyling": [
		3120
	],
	"./semanticTokensStyling.js": [
		3120
	],
	"./semanticTokensStylingService": [
		7129
	],
	"./semanticTokensStylingService.js": [
		7129
	],
	"./textModelSync/textModelSync.impl": [
		5212
	],
	"./textModelSync/textModelSync.impl.js": [
		5212
	],
	"./textModelSync/textModelSync.protocol": [
		9421,
		9421
	],
	"./textModelSync/textModelSync.protocol.js": [
		9421,
		9421
	],
	"./textResourceConfiguration": [
		683
	],
	"./textResourceConfiguration.js": [
		683
	],
	"./treeSitterParserService": [
		4051
	],
	"./treeSitterParserService.js": [
		4051
	],
	"./treeViewsDnd": [
		7542
	],
	"./treeViewsDnd.js": [
		7542
	],
	"./treeViewsDndService": [
		6443
	],
	"./treeViewsDndService.js": [
		6443
	],
	"./unicodeTextModelHighlighter": [
		3072
	],
	"./unicodeTextModelHighlighter.js": [
		3072
	],
	"monaco-editor/esm/vs/editor/common/services/editorBaseApi": [
		2212
	],
	"monaco-editor/esm/vs/editor/common/services/editorBaseApi.js": [
		2212
	],
	"monaco-editor/esm/vs/editor/common/services/editorSimpleWorker": [
		104
	],
	"monaco-editor/esm/vs/editor/common/services/editorSimpleWorker.js": [
		104
	],
	"monaco-editor/esm/vs/editor/common/services/editorWorker": [
		4225
	],
	"monaco-editor/esm/vs/editor/common/services/editorWorker.js": [
		4225
	],
	"monaco-editor/esm/vs/editor/common/services/editorWorkerHost": [
		9487
	],
	"monaco-editor/esm/vs/editor/common/services/editorWorkerHost.js": [
		9487
	],
	"monaco-editor/esm/vs/editor/common/services/findSectionHeaders": [
		730
	],
	"monaco-editor/esm/vs/editor/common/services/findSectionHeaders.js": [
		730
	],
	"monaco-editor/esm/vs/editor/common/services/getIconClasses": [
		4809
	],
	"monaco-editor/esm/vs/editor/common/services/getIconClasses.js": [
		4809
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeatureDebounce": [
		8787
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeatureDebounce.js": [
		8787
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeatures": [
		8715
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeatures.js": [
		8715
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeaturesService": [
		5468
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeaturesService.js": [
		5468
	],
	"monaco-editor/esm/vs/editor/common/services/languageService": [
		5297
	],
	"monaco-editor/esm/vs/editor/common/services/languageService.js": [
		5297
	],
	"monaco-editor/esm/vs/editor/common/services/languagesAssociations": [
		1011
	],
	"monaco-editor/esm/vs/editor/common/services/languagesAssociations.js": [
		1011
	],
	"monaco-editor/esm/vs/editor/common/services/languagesRegistry": [
		7780
	],
	"monaco-editor/esm/vs/editor/common/services/languagesRegistry.js": [
		7780
	],
	"monaco-editor/esm/vs/editor/common/services/markerDecorations": [
		3473
	],
	"monaco-editor/esm/vs/editor/common/services/markerDecorations.js": [
		3473
	],
	"monaco-editor/esm/vs/editor/common/services/markerDecorationsService": [
		4286
	],
	"monaco-editor/esm/vs/editor/common/services/markerDecorationsService.js": [
		4286
	],
	"monaco-editor/esm/vs/editor/common/services/model": [
		2597
	],
	"monaco-editor/esm/vs/editor/common/services/model.js": [
		2597
	],
	"monaco-editor/esm/vs/editor/common/services/modelService": [
		3538
	],
	"monaco-editor/esm/vs/editor/common/services/modelService.js": [
		3538
	],
	"monaco-editor/esm/vs/editor/common/services/resolverService": [
		3537
	],
	"monaco-editor/esm/vs/editor/common/services/resolverService.js": [
		3537
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensDto": [
		1351
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensDto.js": [
		1351
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensProviderStyling": [
		452
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensProviderStyling.js": [
		452
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStyling": [
		3120
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStyling.js": [
		3120
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStylingService": [
		7129
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStylingService.js": [
		7129
	],
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.impl": [
		5212
	],
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.impl.js": [
		5212
	],
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.protocol": [
		9421,
		9421
	],
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.protocol.js": [
		9421,
		9421
	],
	"monaco-editor/esm/vs/editor/common/services/textResourceConfiguration": [
		683
	],
	"monaco-editor/esm/vs/editor/common/services/textResourceConfiguration.js": [
		683
	],
	"monaco-editor/esm/vs/editor/common/services/treeSitterParserService": [
		4051
	],
	"monaco-editor/esm/vs/editor/common/services/treeSitterParserService.js": [
		4051
	],
	"monaco-editor/esm/vs/editor/common/services/treeViewsDnd": [
		7542
	],
	"monaco-editor/esm/vs/editor/common/services/treeViewsDnd.js": [
		7542
	],
	"monaco-editor/esm/vs/editor/common/services/treeViewsDndService": [
		6443
	],
	"monaco-editor/esm/vs/editor/common/services/treeViewsDndService.js": [
		6443
	],
	"monaco-editor/esm/vs/editor/common/services/unicodeTextModelHighlighter": [
		3072
	],
	"monaco-editor/esm/vs/editor/common/services/unicodeTextModelHighlighter.js": [
		3072
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9204;
module.exports = webpackAsyncContext;